import React, { createContext, useState } from 'react';

// Create a new context
const UserRoleContext = createContext();

// Create a provider component for the context
const UserRoleProvider = ({ children }) => {
  const [userRole, setUserRole] = useState('');
  const [viewFlag, setViewFlag] = useState(true);


  const updateUserRole = (role) => {
    setUserRole(role);
  };

  // Provide the userRole state and the update function to the child components
  return (
    <UserRoleContext.Provider value={{ userRole, updateUserRole, viewFlag, setViewFlag }}>
      {children}
    </UserRoleContext.Provider>
  );
};

export { UserRoleContext, UserRoleProvider };
